import { useMemo } from "react"

import { ADJUSTMENT_REASON_TO_LABEL, ADJUSTMENT_TYPE_TO_LABEL } from "../../Adjustment/constants"
import { ADJUSTMENT_STATUS_TO_LABEL } from "../constants"

import type {
  InventoryAdjustmentReason,
  InventoryAdjustmentStatus,
  InventoryAdjustmentType,
} from "@/graphql/codegen/graphql"
import { UserCreatedRecordType } from "@/graphql/codegen/graphql"
import { useGetUserOptions } from "@/hooks/useGetUserOptions"
import { useGetWarehouseOptions } from "@/hooks/useGetWarehouseOptions"
import type { Option } from "@/types/form-fields"

interface UseAdjustmentHistoryFilterOptionsReturn {
  adjustmentTypeOptions: Option<InventoryAdjustmentType>[]
  statusOptions: Option<InventoryAdjustmentStatus>[]
  reasonOptions: Option<InventoryAdjustmentReason>[]
  warehouseOptions: Option<string>[]
  isWarehouseOptionsFetching: boolean
  adjustedByOptions: Option<string>[]
  isAdjustedByOptionsFetching: boolean
}
export const useAdjustmentHistoryFilterOptions = (): UseAdjustmentHistoryFilterOptionsReturn => {
  const { warehouseOptions, isFetching: isWarehouseOptionsFetching } = useGetWarehouseOptions({
    isInventoryRelated: true,
  })
  const { userOptions: adjustedByOptions, isFetching: isAdjustedByOptionsFetching } = useGetUserOptions({
    createdRecordTypes: [UserCreatedRecordType.InventoryAdjustment],
  })

  const adjustmentTypeOptions = useMemo<Option<InventoryAdjustmentType>[]>(
    () =>
      Object.entries(ADJUSTMENT_TYPE_TO_LABEL).map(([value, label]) => ({
        value: value as InventoryAdjustmentType,
        label,
      })),
    []
  )

  const statusOptions = useMemo<Option<InventoryAdjustmentStatus>[]>(
    () =>
      Object.entries(ADJUSTMENT_STATUS_TO_LABEL).map(([value, label]) => ({
        value: value as InventoryAdjustmentStatus,
        label,
      })),
    []
  )

  const reasonOptions = useMemo<Option<InventoryAdjustmentReason>[]>(
    () =>
      Object.entries(ADJUSTMENT_REASON_TO_LABEL).map(([value, label]) => ({
        value: value as InventoryAdjustmentReason,
        label,
      })),
    []
  )

  return {
    adjustmentTypeOptions,
    statusOptions,
    reasonOptions,
    warehouseOptions,
    isWarehouseOptionsFetching,
    adjustedByOptions,
    isAdjustedByOptionsFetching,
  }
}
